import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-request',
  templateUrl: './icon-request.component.html',
  styleUrls: ['./icon-request.component.scss']
})
export class IconRequestComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
